import type { SVGProps } from 'react';

const SvgPersonalization = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="personalization">
      <path d="M1.55 26.35a3.57 3.57 0 0 0 3.53 3h3.29a3.57 3.57 0 0 0 3.53-3l1.26-7.73a3.58 3.58 0 0 0-3.54-4.15h-5.8a3.58 3.58 0 0 0-3.53 4.15Zm.69-9.65a2.06 2.06 0 0 1 1.58-.7h5.8a2.06 2.06 0 0 1 2.05 2.41l-1.25 7.73a2.08 2.08 0 0 1-2.05 1.75H5.08A2.07 2.07 0 0 1 3 26.11l-1.23-7.73a2.1 2.1 0 0 1 .47-1.68M1.72 7.73a5.1 5.1 0 1 0 5.1-5.1 5.1 5.1 0 0 0-5.1 5.1m8.7 0a3.6 3.6 0 1 1-3.6-3.6 3.6 3.6 0 0 1 3.6 3.6M21.94 9h-2V2.63h-1.5V9h-2a.75.75 0 0 0-.75.75v4.62a.75.75 0 0 0 .75.75h2v14.25h1.5V15.11h2a.76.76 0 0 0 .75-.75V9.74a.76.76 0 0 0-.75-.74m-.75 4.62h-4v-3.13h4ZM27.46 2.63v14.26h-2a.75.75 0 0 0-.75.75v4.62a.75.75 0 0 0 .75.75h2v6.36H29V23h2a.76.76 0 0 0 .75-.75v-4.61a.76.76 0 0 0-.75-.75h-2V2.63Zm2.77 18.88h-4v-3.12h4Z" />
    </g>
  </svg>
);

export default SvgPersonalization;
